import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Zoom } from 'react-awesome-reveal';
import axios from 'axios';
import './Slider.css';

function Slider() {
  const [images, setImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState({});

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const res = await axios.get("https://himchatterjee.in/backend/photo_slider.php");
      setImages(res.data);

      const initialLoading = {};
      res.data.forEach(img => {
        initialLoading[img.id] = true;
      });
      setLoadingImages(initialLoading);

    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const handleImageLoad = (id) => {
    setLoadingImages(prev => ({ ...prev, [id]: false }));
  };

  return (
    <section className='main'>
      <div className="wrapper">
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
          spaceBetween={50}
          slidesPerView={1}
          navigation
          autoplay={{ delay: 9000 }}
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
        >
          {images.map((img) => (
            <SwiperSlide key={img.id} className="slide">
              <Zoom duration={1500}>
                <div className="image-container">
                  {loadingImages[img.id] && (
                    <div className="loader-overlay">
                      <div className="loader"></div>
                    </div>
                  )}

                  <img
                    src={`https://himchatterjee.in/backend/uploads/${img.name}`}
                    alt={`Slide ${img.id}`}
                    className='photo'
                    style={{ display: loadingImages[img.id] ? "none" : "block" }}
                    onLoad={() => {
                      console.log("Image loaded:", img.name);
                      handleImageLoad(img.id);
                    }}
                    onError={() => {
                      console.error("Failed to load image:", img.name);
                      handleImageLoad(img.id);
                    }}
                  />

                  <div className="image-data">
                    <h2>{img.title}</h2>
                  </div>
                </div>

              </Zoom>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Slider;
